import React, { useEffect, useMemo, useState } from 'react'
import { StackScreenProps } from '@react-navigation/stack'
import {
  ContributionStatus,
  ContributionType,
  useContributionsForClusterQuery,
} from '../../../generated/graphql'
import { useIsFocused } from '@react-navigation/native'
import { Contribution, ContributionFilter } from './types'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { ContributionList } from './components/contribution.list'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { SocketEvents, useSocketRoom } from '../../../socket/socket.hooks'
import { AppNavigatorParams } from '../../../navigation/types'

export function ClusterContributionsScreen({
  route,
  navigation,
}: StackScreenProps<AppNavigatorParams, 'ClusterContributions'>) {
  const isFocused = useIsFocused()
  const { clusterId } = route.params
  const globalStyles = useGlobalStyles()
  const [filter, setFilter] = useState<ContributionFilter>({
    status: 'All',
    type: 'All',
  })

  const { data, refetch } = useContributionsForClusterQuery({
    variables: {
      clusterId,
      status: filter.status,
      type: filter.type,
    },
    fetchPolicy: 'cache-and-network',
  })

  useSocketRoom(clusterId).event(SocketEvents.Refresh, refetch)

  useEffect(() => {
    if (isFocused) {
      refetch()
    }
  }, [isFocused])
  const contributions: Contribution[] = useMemo(
    () =>
      (data?.contributionsByCluster || []).filter(
        (c) =>
          c.contributionType != ContributionType.Reserved &&
          c.status != ContributionStatus.Cancelled &&
          c.status != ContributionStatus.Censured
      ),
    [data]
  )

  return (
    <ScreenWrapper withScrollView={false} style={globalStyles.pageContainer}>
      <ContributionList
        contributions={contributions}
        type={filter.type}
        status={filter.status}
        onContributionPress={(contribution) => {
          navigation.navigate('PerspectiveContribution', {
            contributionId: contribution.id,
          })
        }}
        onFilterChange={(type, status) => {
          setFilter({ status, type })
        }}
      />
    </ScreenWrapper>
  )
}
export default ClusterContributionsScreen
